module.exports = __webpack_public_path__ + "static/img/playy.f5f02e15.png";